import type { RouteObject } from 'react-router';

import { lazy } from 'react';

const UnauthorizedPage = lazy(() => import('src/pages/error/401'));
const NotFoundPage = lazy(() => import('src/pages/error/404'));
const ForbiddenPage = lazy(() => import('src/pages/error/403'));

export const errorRoutes: RouteObject[] = [
  {
    path: 'error',
    children: [
      {
        path: '401',
        element: <UnauthorizedPage />,
      },
      {
        path: '404',
        element: <NotFoundPage />,
      },
      {
        path: '403',
        element: <ForbiddenPage />,
      },
    ],
  },
];
